import { useNavigate } from "react-router";
import { CheckCircleIcon, FireIcon, PenNibIcon } from "@phosphor-icons/react";
import { useShallow } from "zustand/shallow";
import { CheckFatIcon } from "@phosphor-icons/react/dist/ssr";
import { useEffect, useMemo } from "react";

import { useBoundStore } from "@/app/store";
import { StatCard } from "@/features/statistics/components/StatCard";
import { TodayTodos } from "./TodayTodos";
import { ActionCard } from "./ActionCard";
import { usePageLayout } from "@/app/hooks/usePageLayout";

export function HomeRoute() {
  const userId = useBoundStore(useShallow((state) => state.user.id));
  const isActive = useBoundStore(useShallow((state) => state.device.isActive));

  const {
    today: todayStats,
    yesterday: yesterdayStats,
    fetchDailyStats,
  } = useBoundStore(
    useShallow((state) => ({
      today: state.dailyStats.today,
      yesterday: state.dailyStats.yesterday,
      fetchDailyStats: state.dailyStats.fetchDailyStats,
    }))
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (userId && isActive) {
      fetchDailyStats(userId, "today");
      fetchDailyStats(userId, "yesterday");
    }
  }, [userId, fetchDailyStats, isActive]);

  const handleWritePress = () => {
    navigate("/notes/0", { replace: true });
    navigate("/notes/0/create");
  };

  const handleDoPress = () => {
    navigate("/todos", { replace: true });
    navigate("/todos?todo-state-open=true");
  };

  // Static layout config - usePageLayout is optimal here since no dynamic callbacks
  const pageLayoutConfig = useMemo(
    () => ({
      className: "mx-auto w-full max-w-3xl",
      showBottomNavigation: true,
      navbar: { hideBack: true, title: "Home" },
    }),
    []
  );

  usePageLayout(pageLayoutConfig);

  return (
    <>
      <div className="grid grid-cols-2 gap-6 sm:grid-cols-4">
        <StatCard
          color="amber"
          description="Days in a row "
          icon={FireIcon}
          value={todayStats?.current_streak ?? 0}
          title="Current streak"
          backSide={{ value: todayStats?.longest_streak ?? 0, title: "Longest streak" }}
        />
        <StatCard
          color="teal"
          description="Completed today"
          icon={CheckFatIcon}
          value={todayStats?.todos_completed ?? 0}
          title="Todos"
          backSide={{
            description: "Completed yesterday",
            value: yesterdayStats?.todos_completed ?? 0,
          }}
        />
        <TodayTodos />
        <ActionCard icon={PenNibIcon} label="Write" onPress={handleWritePress} />
        <ActionCard icon={CheckCircleIcon} label="Do" onPress={handleDoPress} />
      </div>
    </>
  );
}
